import React from 'react';

import { BaseIconProps } from '.';

export const ArrowRight = ({ fill }: BaseIconProps) => (
  <g
    fill={fill}
    transform="matrix(63.092087,0,0,63.092087,-8.420068,21.977352)"
  >
    <path
      d="m 0.5,8 h 16.0784 m 0,0 L 9.5,1 M 16.5784,8 9.5,15"
      stroke="#ffffff"
      strokeWidth="1.5"
    />
  </g>
);
